import { getDataLayerItem } from "./helpers/get-data-layer-item"
import { DataLayerItem } from "./helpers/types"

export function dataLayerAddToCart({ id, name, price }: DataLayerItem) {
  if (window["dataLayer"]) {
    const item = getDataLayerItem({ id, name, price }, 1, 0)
    window["dataLayer"].push({ ecommerce: null })

    window["dataLayer"].push({
      event: "add_to_cart",
      ecommerce: {
        currency: "EUR",
        value: item.price,
        items: [item],
      },
    })
  }
}
